export default "__VITE_ASSET__BMMay7dA__"